import React, { Suspense } from 'react';
import { Box, Stack } from '@mui/material';
import { WorkspaceAlarmsAction } from './WorkspaceAlarmsAction';
import WorkspaceCommanderStatusAction from './WorkspaceCommanderStatusAction';
import WorkspaceAPI from '../../../../../redux/workspace/WorkspaceAPI';
import { skipToken } from '@reduxjs/toolkit/query';
import { WorkspaceAPIResponse } from '../../../../../redux/workspace/WorkspaceAPI.model';

export interface WorkspaceActionsProps {
  workspace: WorkspaceAPIResponse | undefined;
  // usually on header, but on items is not needed
  active?: boolean;
}

export interface WorkspaceActionsInProps {
  workspaceId: string | undefined;
  // usually on header, but on items is not needed
  active?: boolean;
}

function WorkspaceActions(props: WorkspaceActionsInProps) {
  const { workspaceId } = props;
  const { data: workspace } = WorkspaceAPI.useGetWorkspaceByIdQuery(
    workspaceId ?? skipToken
  );
  return (
    <Stack direction={'row'} spacing={1}>
      <Suspense fallback={null}>
        <WorkspaceCommanderStatusAction {...props} workspace={workspace} />
      </Suspense>
      <Box
        sx={{
          width: '6rem',
          height: '3rem',
        }}
      >
        <WorkspaceAlarmsAction {...props} workspace={workspace} />
      </Box>
    </Stack>
  );
}

export default WorkspaceActions;
